import script from "./StatisticsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsEditor.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsEditor.vue?vue&type=style&index=0&id=61ade788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ade788"]])

export default __exports__